import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.string.replace-all.js";
const controlList = [{
  name: '单选',
  value: 1
}, {
  name: '日期选择',
  value: 2
}, {
  name: '层级下拉',
  value: 3
}, {
  name: '文本框',
  value: 4
}, {
  name: '复选',
  value: 5
}, {
  name: '下拉选择',
  value: 6
}];
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { planBudgetConfig, planPreview, budgetConfigFilter } from '../request';
import budgetControls from './budgetControls.vue';
export default {
  components: {
    budgetControls
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    info: Array,
    list: Array,
    budgetForm: Object,
    formParams: Array,
    preview: Object,
    id: {}
  },
  watch: {
    visible(newV) {
      if (newV == true) {
        this.getData();
      }
      this.budgetVisible = newV;
    },
    info: {
      handler(newV) {
        if (newV && newV.length) {
          this.paramsList = newV;
          let arr = [];
          this.paramsList.map(item => {
            if (this.form.params.includes(item.mark)) {
              arr.push(item.mark);
            }
          });
          this.form.params = arr;
        }
        this.changeParams(this.form.params, false);
      },
      deep: true
    },
    // budgetForm: {
    //   handler(newV) {
    //     if (newV) {
    //     }
    //   },
    //   deep: true
    // },
    formParams: {
      handler(newV) {
        if (newV) {
          if (this.form.params.length) {
            this.form.params.splice(0);
          }
          this.form.params.push(...newV);
          this.changeParams(this.form.params, false);
        }
      },
      deep: true
    },
    preview: {
      handler(newV) {
        if (newV) {
          this.previewData = newV;
          this.form.type = newV.type;
          this.$set(this.previewData, 'dimensions', newV.dimensions);
          this.$set(this.previewData, 'moneyInfo', newV.moneyInfo);
          this.$set(this.previewData, 'type', newV.type);
        }
      },
      deep: true
    }
  },
  computed: {
    getAmount() {
      let moneyInfo = this.previewData.moneyInfo;
      if (this.list.find(i => i.isDefault) || moneyInfo && moneyInfo.find(i => i.selected)) {
        return moneyInfo && moneyInfo.find(i => i.selected) && moneyInfo.find(i => i.selected).amount || '--';
      } else if (moneyInfo.length == 1) {
        return this.previewData.moneyInfo[0].amount || '--';
      } else {
        return '--';
      }
    },
    getPrice() {
      let moneyInfo = this.previewData.moneyInfo;
      if (this.list.find(i => i.isDefault) || moneyInfo && moneyInfo.find(i => i.selected)) {
        return moneyInfo && moneyInfo.find(i => i.selected) && moneyInfo.find(i => i.selected).price || '--';
      } else if (moneyInfo.length == 1) {
        return this.previewData.moneyInfo[0].price || '--';
      } else {
        return '--';
      }
    }
  },
  data() {
    return {
      rule: {
        type: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('试算接口')
        }],
        params: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('试算参数')
        }]
      },
      controlList,
      budgetVisible: false,
      data: [],
      columns: [{
        slots: {
          title: '方案字段'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        slots: {
          title: '标识'
        },
        dataIndex: 'mark',
        key: 'mark',
        align: 'center'
      }, {
        slots: {
          title: '前端显示字段'
        },
        dataIndex: 'field',
        key: 'field',
        align: 'center',
        width: 180,
        scopedSlots: {
          customRender: 'field'
        }
      }, {
        slots: {
          title: '控件'
        },
        dataIndex: 'controls',
        key: 'controls',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'controls'
        }
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      currentStep: 0,
      form: {
        params: []
      },
      planform: {
        amountIndex: undefined
      },
      paramsList: [],
      rules: {
        amountIndex: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('保障额度')
        }]
      },
      defaultData: [],
      previewData: {},
      areaCode: [],
      money: [],
      amount: undefined,
      price: undefined,
      changeParamsStatus: false,
      backups2: {},
      recordParams: [],
      spinning: false,
      replaceName: ['缴费期限', '保障年龄', '保障期限']
    };
  },
  mounted() {
    this.paramsList = this.info;
    // this.form.type = this.budgetForm.type;
    if (this.formParams.length) {
      if (this.form.params.length) {
        this.form.params.splice(0);
      }
      this.form.params.push(...this.formParams);
    }
    this.$set(this.form, 'type', this.budgetForm.type);
  },
  methods: {
    unitReplace(value) {
      if (value) {
        let _value = value.replaceAll('年', this.$t('年')).replaceAll('季', this.$t('季')).replaceAll('月', this.$t('月')).replaceAll('周', this.$t('周')).replaceAll('天', this.$t('天'));
        return this.$t(_value);
      }
    },
    selectAmount(e) {
      this.planform.amountIndex = e.target.value;
      this.amount = this.money[e.target.value].amount;
      this.price = this.money[e.target.value].price;
    },
    renderParams(data, status = false) {
      if (data.type) {
        this.form.type = data.type;
      }
      if (data.paramConfig && data.paramConfig.length) {
        this.defaultData = data.paramConfig;
        if (!status) {
          this.form.params = this.defaultData.map(i => {
            return i[0];
          });
        }
        this.changeParams(this.form.params, status);
      } else {
        this.defaultData = [];
      }
    },
    beFormRule(data) {
      let arr = ['1', '2', '3', '5', '6'];
      data.forEach(item => {
        if (arr.includes(item[1].controls)) {
          var _item$;
          this.rules[item[0]] = [{
            required: true,
            trigger: 'change',
            message: this.$t('请选择') + `${(_item$ = item[1]) === null || _item$ === void 0 ? void 0 : _item$.name}`
          }];
        } else {
          var _item$2;
          this.rules[item[0]] = [{
            required: true,
            trigger: 'blur',
            message: this.$t('请输入') + `${(_item$2 = item[1]) === null || _item$2 === void 0 ? void 0 : _item$2.name}`
          }];
        }
      });
    },
    filterControlsValue(info) {
      if (info.controls == '3' || info.controls == '5') {
        if (!Array.isArray(info.controlsDefaultValue)) {
          info.controlsDefaultValue = [];
        }
      }
      return info;
    },
    onNext() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          if (this.data.find(i => !i.controls)) {
            return this.$message.warn(this.$t('请选择') + this.$t('参数控件类型'));
          } else {
            if (this.changeParamsStatus === true) {
              this.defaultData = [];
            }
            let planInfo = this.list.filter(item => item.status == 1);
            const res = await planBudgetConfig({
              insuranceId: this.id,
              planInfo,
              dimensions: this.data
            });
            this.defaultData = Object.entries(res);
            this.recordParams = this.form.params;
            console.log(this.defaultData, 2222);
            this.beFormRule(this.defaultData);
            this.getAreaCode(this.defaultData);
            this.money = [];
            this.planform.amountIndex = undefined;
            this.amount = undefined;
            this.price = undefined;
            this.currentStep = 1;
          }
        }
      });
    },
    onLast() {
      this.currentStep = 0;
      this.spinning = false;
    },
    disabledAge() {
      this.defaultData.map((item, i) => {
        if (item[0] == 'age' && item[1].controlsDefaultValue) {
          this.defaultData[i][1].disabled = true;
          this.$set(this.defaultData[i][1], 'disabled', true);
        }
      });
    },
    async planPreviewData() {
      const res = await planPreview({
        insuranceId: this.id
      });
      this.previewData = res || {};
      this.previewData.dimensions = res.paramConfig ? JSON.parse(res.paramConfig) : [];
    },
    delBudget(record, i) {
      this.data.splice(i, 1);
      let _index = this.form.params.findIndex(i => i == record.mark);
      if (_index != -1) {
        this.form.params.splice(_index, 1);
      }
    },
    getData() {},
    closeAdd() {
      this.$emit('cancel');
      this.renderParams(this.defaultData, false);
      this.changeParamsStatus = false;
      this.currentStep = 0;
      this.spinning = false;
    },
    saveBudgetParams() {
      let res = this.defaultData.find(i => {
        if (!i[1].controlsDefaultValue && i[1].controlsDefaultValue !== 0 || Array.isArray(i[1].controlsDefaultValue) && !i[1].controlsDefaultValue.length) {
          return i;
        }
      });
      if (res) {
        var _res$;
        return this.$message.error(((_res$ = res[1]) === null || _res$ === void 0 ? void 0 : _res$.name) + ' ' + this.$t('为必填项'));
      }
      if (!this.amount || !this.price) {
        return this.$message.warning(this.$t('未查找到方案，请重新配置'));
      }
      let moneyInfo = [];
      this.money.map((item, index) => {
        if (index == this.planform.amountIndex) {
          item.selected = true;
          moneyInfo.push(item);
        }
        //  else {
        //   item.selected = false;
        // }
        // return item;
      });
      let obj = {
        type: this.form.type,
        paramConfig: recursionCopy(this.defaultData.map(i => i[1])),
        moneyInfo
      };
      this.changeParamsStatus = false;
      this.$emit('onSaveBudget', recursionCopy(obj));
      this.closeAdd();
    },
    changeParams(a, status) {
      this.changeParamsStatus = status;
      let oldData = recursionCopy(this.data);
      this.data.splice(0);
      if (a !== null && a !== void 0 && a.length) {
        a.forEach(item => {
          let res = this.paramsList.find(i => i.mark === item);
          if (res) {
            this.data.push(Object.assign({
              field: res.field ? res.field : res.name
            }, res));
          }
        });
        this.data = this.data.map(item => {
          oldData.forEach(old => {
            if (old.mark === item.mark) {
              item = old;
            }
          });
          return item;
        });
      }
    },
    async filterConfig(obj, index, isDisabled) {
      if (!isDisabled) {
        this.spinning = true;
      }
      this.defaultData[index][1].controlsDefaultValue = obj.controlsDefaultValue;
      this.defaultData[index][1].controlsDefaultType = obj.controlsDefaultType;
      let dimensions = Object.fromEntries(recursionCopy(this.defaultData));
      const res = await budgetConfigFilter({
        insuranceId: this.id,
        planInfo: this.list,
        dimensions
      });
      this.defaultData = Object.entries(res.dimensions);
      this.money = res.money;
      // this.planform.amountIndex = undefined;
      // this.price = undefined;
      if (!res.money.length) {
        this.planform.amountIndex = undefined;
        this.price = undefined;
      }
      res.money.forEach((item, i) => {
        if (item.selected) {
          this.planform.amountIndex = i;
          this.price = item.price;
        }
      });
      this.getAreaCode(this.defaultData);
      this.spinning = false;
      setTimeout(() => {
        this.spinning = false;
      }, 30000);
    },
    getAreaCode(data) {
      data.map(item => {
        if (item[0] === 'areaPrice') {
          this.areaCode = item[1].controlsValue;
        }
      });
    }
  }
};